<template>
  <div v-if="page === 'return-confirmation'">
    <h5>Delivery Information</h5>
    <div class="margin-top-xs">
      <div v-text="data.firstName + ' ' + data.lastName"></div>
      <div v-if="data.address.addressLine1" v-text="data.address.addressLine1"></div>
      <div v-if="data.address.addressLine2" v-text="data.address.addressLine2"></div>
      <div v-if="data.address.addressLine3" v-text="data.address.addressLine3"></div>
      <div v-if="data.address.city || data.address.state || data.address.postalCode">
        {{ data.address.city }}
        {{ data.address.state }}
        {{ data.address.postalCode }}
      </div>
      <div v-if="data.dayPhone" v-text="phoneFormat(data.dayPhone)"></div>
      <div v-if="data.emailAddress" class="email-address" v-text="data.emailAddress"></div>
    </div>
  </div>
  <div v-else class="margin-bottom-s">
    <h5 class="margin-bottom-xxs" v-text="TRACK_PACKAGE.deliveryInformationText"></h5>
    <div id="delivery-information" v-text="emailAddress"></div>
  </div>
</template>

<script setup>
import { phoneFormat } from '@vue-util/forms/mask-util';
import { TRACK_PACKAGE } from 'config';

defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  page: {
    type: String,
    default: '',
  },
  emailAddress: {
    type: String,
    default: '',
  },
});
</script>
